/**
 * The column every page sets its content in: centred, at most 1152px of
 * content, and the same gutter on every screen, so switching pages never
 * moves the edges.
 */
export const PAGE_COLUMN = "mx-auto w-full max-w-[75rem] px-6";
